module.exports = __webpack_public_path__ + "static/banner-tablet-67f8d8a321302d7634938ad9e840b229.png";